import { isPast } from 'date-fns';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DateInput } from 'src/components/enterprise/components/DateInput/DateInput';
import { useToDateHandler } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/hooks/useToDateHandler';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface MonthAvailableToDateInputProps {
  disabled?: boolean;
  id: string;
  name: string;
}

export const MonthAvailableToDateInput = ({
  disabled = false,
  id,
  name,
}: MonthAvailableToDateInputProps): JSX.Element => {
  const { errors, control } = useFormContext<IMealCreditFormFields>();
  const { cycleStartDate, cycleEndDate } = useToDateHandler(name);

  return (
    <DateInput
      id={id}
      name={name}
      label="To"
      disabled={disabled}
      control={control}
      error={errors[name]}
      rules={{
        required: 'Required',
      }}
      disabledDays={{
        before:
          !cycleStartDate || isPast(cycleStartDate)
            ? new Date()
            : cycleStartDate,
        after: cycleEndDate,
      }}
    />
  );
};
